import { render, staticRenderFns } from "./SidebarMenu.vue?vue&type=template&id=39baf58a&scoped=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=ts"
export * from "./SidebarMenu.vue?vue&type=script&lang=ts"
import style0 from "./SidebarMenu.vue?vue&type=style&index=0&id=39baf58a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39baf58a",
  null
  
)

export default component.exports